module.exports = __webpack_public_path__ + "static/img/move1.821035f.png";


//////////////////
// WEBPACK FOOTER
// ./static/hk/img/news2/move1.png
// module id = LsNE
// module chunks = 7